/**
 * Created by bootdo.
 */
import {Message} from "element-ui";


import axios from 'axios'
import store from "../vuex/store"
import {
  bus
} from '../bus.js'

axios.defaults.withCredentials = true;
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
//  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';//配置请求头
// 使用由库提供的配置的默认值来创建实例
// 此时超时配置的默认值是 `0`
let service = axios.create()

// 用户信息
let userInfo = JSON.parse(window.localStorage.getItem('userinfo'));

// 覆写库的超时默认值
// 现在，在超时前，所有请求都会等待 10 秒
service.defaults.timeout = 10000
//添加一个请求拦截器
service.interceptors.request.use(
  config => {
    config.headers={
      "X-Content-Type-Options":"nosniff",
      "X-Frame-Options":"SAMEORIGIN",
      "X-XSS-Protection":1,
      "mode":"block",

    }
    if (window.localStorage.getItem('access-token')) {
      config.headers.Authorization=window.localStorage.getItem('access-token');
    }
    if (config.method == 'post' && userInfo && config.data) {
      // config.data.enterpriseId = userInfo.enterpriseId;

      // if ( config.params.enterpriseId == null || config.params.enterpriseId == ''){
      //   config.params.enterpriseId =config.params.enterpriseId;
      // }

      if ( config.data.enterpriseId != userInfo.enterpriseId){
        config.data.enterpriseId =config.data.enterpriseId;
      }else {
        config.data.enterpriseId =userInfo.enterpriseId;
      }



    } else if (config.method == 'get' && userInfo && config.params) {
      if ( config.params.enterpriseId != userInfo.enterpriseId){
        config.params.enterpriseId =config.params.enterpriseId;
      }else {
        config.params.enterpriseId =userInfo.enterpriseId;
      }

    }
    store.state.loading = true
    return config
  },
  error => {
    return Promise.reject(error)
  }
);
// 添加一个响应拦截器
service.interceptors.response.use(function(response) {
  store.state.loading = false
  console.log(response)
  //if(response.status == 500){
    // that.$message.error({
    //   showClose: true,
    //   message: result.message,
    //   duration: 2000
    // });
  //}
  if (response.data && response.data.code) {
    if (parseInt(response.data.code) === 401) {
      //未登录
      bus.$emit('goto', '/login')
    }
    if (parseInt(response.data.code) === 204) {
      // alert('授权已过期，请联系服务提供商')
      Message('授权已过期，请联系服务提供商')
      //未登录
      // bus.$emit('goto', '/login')
    }
  }

  return response;
}, function(error) {
  console.log(error);
  if (parseInt(error.response.status) === 401 && error.response.data.error == 'invalid_token') {
    bus.$emit('goto', '/login')
  } else {

    store.state.loading = false
    // Do something with response error
    return Promise.reject(error);
  }

});

//基地址
let base = process.env.API_ROOT

//通用方法
export const POST = (url, params) => {

  return service.post(`${base}${url}`, params).then(res => res.data)
}

export const GETBLOB = (url, params) => {
  return service.get(`${base}${url}`, {
    params: params,
    responseType: "blob"
  }).then(res => res.data)
}

export const GET = (url, params) => {
  return service.get(`${base}${url}`, {
    params: params,
  }).then(res => res.data)
}

export const actiGET = (url, params) => {
  console.error(`${url}`);
  return service.get(`${url}`, {
    params: params,
  }).then(res => res.data)
}

export const GET_BYTE = (url, params) => {
  return service.get(`${base}${url}`, {
    responseType: 'arraybuffer',
    params: params
  }).then(res => res.data)
}

export const PUT = (url, params) => {
  return service.put(`${base}${url}`, params).then(res => res.data)
}

export const DELETE = (url, params) => {
  return service.delete(`${base}${url}`, {
    params: params
  }).then(res => res.data)
}

export const PATCH = (url, params) => {
  return service.patch(`${base}${url}`, params).then(res => res.data)
}



// WEBPACK FOOTER //
// ./src/api/index.js